// modules
import { handleActions } from 'redux-actions'

// actions
import { setIsAddReferralModalVisible } from 'src/store/modules/referral/actionCreators'

const initialState = {
  isAddReferralModalVisible: false
}

export default handleActions(
  {
    [`${setIsAddReferralModalVisible}`](
      state: any,
      { payload: isAddReferralModalVisible }
    ) {
      return {
        ...state,
        isAddReferralModalVisible
      }
    }
  },
  initialState
)
